"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  methods: {
    openDetail: function openDetail(projectId) {
      // Navigate to the card detail page with project ID
      this.$router.push({
        path: '/welfare/cardDetail',
        query: {
          projectId: projectId
        }
      });
    }
  }
};